import { StatusCadastro } from '../shared/enums/status-cadastro.enum';

export class CentroCustoCadastro {
    public status: StatusCadastro;
    constructor(
        public codigo: string,
        public nome: string,
        public nomeResponsavel: string,
        public emailResponsavel: string
    ) {}
}
